/* Quick-add lifecycle is owned globally by quick-add.js, including home cards. */
// Progressive variant preview: no-JS links still open the real variant URL.
if (!window.pnCollectionsVariantsBound) {
window.pnCollectionsVariantsBound = true;
document.addEventListener('click', event => {
  const swatch = event.target.closest('[data-pn-swatch]');
  if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const card = swatch.closest('[data-pn-card]');
  if (!card) return;
  event.preventDefault();
  card.querySelectorAll('[data-pn-swatch]').forEach(el => el.removeAttribute('aria-current'));
  swatch.setAttribute('aria-current', 'true');
  card.dataset.variantId = swatch.dataset.variantId || '';
  card.querySelectorAll('.pn-quick-error').forEach(el => el.remove());
  card.querySelectorAll('[data-pn-product-link]').forEach(el => el.href = swatch.href);
  const opener = card.querySelector('modal-opener button');
  if (opener) {
    opener.dataset.productUrl = swatch.href;
    opener.dataset.variantMediaId = swatch.dataset.variantMediaId || '';
    const modal = document.getElementById(opener.getAttribute('aria-controls'));
    modal?.loadController?.abort();
  }
  const image = card.querySelector('.pn-card-image');
  if (image && swatch.dataset.image) { image.src = swatch.dataset.image; image.removeAttribute('srcset'); }
  card.classList.add('pn-card-variant-selected');
  const price = card.querySelector('.pn-card-price');
  if (price) {
    price.classList.remove('price--no-compare');
    price.classList.toggle('price--on-sale', swatch.dataset.onSale === 'true');
    price.classList.toggle('price--sold-out', swatch.dataset.available !== 'true');
    price.querySelectorAll('.price__regular .price-item, .price-item--sale').forEach(el => el.textContent = swatch.dataset.price);
    const unit = price.querySelector('.unit-price');
    if (unit) {
      unit.classList.toggle('hidden', !swatch.dataset.unitLabel);
      const amount = unit.querySelector('[data-pn-unit-price]');
      const reference = unit.querySelector('[data-pn-unit-reference]');
      if (amount) amount.textContent = swatch.dataset.unitPrice || '';
      if (reference) reference.textContent = (swatch.dataset.unitReference === '1' ? '' : swatch.dataset.unitReference || '') + (swatch.dataset.unitLabel || '');
    }
    const compare = price.querySelector('.price__compare-price .price-item');
    if (compare) compare.textContent = swatch.dataset.compare;
  }
  let badge = card.querySelector('.pn-card-badge, .badge');
  const label = swatch.dataset.available !== 'true' ? card.dataset.soldOut : swatch.dataset.onSale === 'true' ? card.dataset.save + ' ' + swatch.dataset.saving : '';
  if (label && !badge) {badge = document.createElement('span');badge.className = 'pn-card-badge';card.querySelector('.pn-card-media').append(badge);}
  if (badge) {badge.textContent = label;badge.hidden = !label;badge.dataset.available = swatch.dataset.available;}
  card.dispatchEvent(new CustomEvent('pn:card:variant', {bubbles:true, detail:{variantId:swatch.dataset.variantId, url:swatch.href}}));
});

}

// Progressive links keep Enter/navigation behavior. Arrow keys move and select within a card.
if (!window.pnCollectionsKeyboardBound) {
  window.pnCollectionsKeyboardBound = true;
  document.addEventListener('keydown', event => {
    const current = event.target.closest('[data-pn-swatch]');
    if (!current || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const choices = [...current.closest('[data-pn-card]').querySelectorAll('[data-pn-swatch]')];
    let index = choices.indexOf(current);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length;
    event.preventDefault();
    choices[index].focus();
    choices[index].click();
  });
}
